<template>
  <div class="popup-confirmation" v-if="open">
    <div class="box">
      <div class="heading">
        <span class="title">Let op! Wil je de generator verlaten?</span>
        <ELordIcon icon="close" @click="$emit('close')" />
      </div>
      <div class="content" :class="typeClass">
        <p v-html="content"></p>
      </div>
      <div class="actions">
        <button
          v-for="(a, index) in actions"
          class="emat-btn emat-btn-primary emat-btn-action"
          @click="$emit('action', a.type)"
          :key="index"
          v-text="a.name"
        />
      </div>
    </div>
    <div class="overlay" @click="$emit('close')"></div>
  </div>
</template>

<script>
import ELordIcon from '@/components/utilities/ELordIcon';

export default {
  name: 'PopupConfirm',
  components: { ELordIcon },
  data() {
    return {
      open: false,
      title: '',
      content: '',
      actions: undefined,
      type: 'warning',
    };
  },
  methods: {
    keyRelease(e) {
      if (this.open) {
        if (e.key === 'Escape') {
          this.$emit('close');
        }
      }
    },
  },
  computed: {
    typeClass() {
      return `content-${this.type}`;
    },
  },
  created() {
    window.addEventListener('keyup', this.keyRelease);
  },
  destroyed() {
    window.removeEventListener('keyup', this.keyRelease);
  },
};
</script>
